import { SearchPicker } from "./SearchPicker";

// Dropdown dengan kotak pencarian — untuk daftar agen/user yang panjang (ramah HP)
export function AgentSearchSelect({ options, value, onChange, placeholder = "Pilih agen", testid = "agent-select", triggerClassName = "" }) {
  return <SearchPicker options={options} value={value} onChange={onChange} placeholder={placeholder} searchPlaceholder="Ketik kode / nama / email agen..." emptyText="Tidak ada yang cocok dengan pencarian" title="Pilih Agen" testid={testid} triggerClassName={triggerClassName} />;
}
